import { NavLink, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { site } from '../data/site';

const nav = [['/','Home'],['/layanan','Services'],['/tentang','About'],['/news','News'],['/kontak','Contact']] as const;

export function waLink(message='Halo Vitry, saya ingin berdiskusi mengenai layanan Solusi Aman.') {
  return `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(message)}`;
}

export default function Layout({children}:{children:React.ReactNode}) {
  const [open,setOpen] = useState(false);
  const location = useLocation();
  useEffect(()=>{ setOpen(false); },[location.pathname]);

  return <>
    <a className="skip" href="#main">Skip to content</a>
    <header className="site-header">
      <div className="container nav-wrap">
        <NavLink to="/" className="brand" aria-label="Solusi Aman home">
          <span className="brand-main">solusi</span><span className="brand-accent">aman</span>
        </NavLink>
        <button className="menu-btn" onClick={()=>setOpen(v=>!v)} aria-expanded={open} aria-controls="primary-nav" aria-label="Toggle navigation">☰</button>
        <nav id="primary-nav" className={open?'nav open':'nav'} aria-label="Primary">
          {nav.map(([to,label])=><NavLink key={to} to={to} end={to==='/'}>{label}</NavLink>)}
          <a className="button small" href={waLink()} target="_blank" rel="noreferrer">Discuss Security ↗</a>
        </nav>
      </div>
    </header>
    <main id="main">{children}</main>
    <footer className="footer">
      <div className="container footer-simple">
        <div className="footer-top">
          <div className="brand"><span className="brand-main">solusi</span><span className="brand-accent">aman</span></div>
          <div className="footer-links">
            {nav.map(([to,label])=><NavLink key={to} to={to} end={to==='/'}>{label}</NavLink>)}
            <a href={waLink()} target="_blank" rel="noreferrer">WhatsApp Vitry ↗</a>
          </div>
        </div>
        <div className="footer-meta">© 2026 Solusi Aman · Independent security & engineering for modern web and mobile applications.</div>
      </div>
    </footer>
  </>;
}
